<template>
  <div>
<!--    <v-row class="mb-6">-->
<!--      <v-col>-->
<!--        <span class="sub-header1 color-grey1 bold text-tcdc-grey1">{{ $t('membership.headerContent') }}</span>-->
<!--      </v-col>-->
<!--    </v-row>-->
    <v-row class="mb-6">
      <template v-for="(item, index) of mode === 'about' ? serviceAbout:serviceTopic">
        <v-col :key="index" cols="12" md="5" class="mt-3 mb-6">
          <v-layout>
            <v-flex shrink mr-2>
              <v-img eager width="30" height="30" contain :src="item.icon"></v-img>
            </v-flex>
            <v-flex>
              <div class="sub-header2 text-tcdc-green bold mb-4">{{ item[`title_${lang}`] }}</div>
            </v-flex>
          </v-layout>
          <div class="vhtml mb-3" v-html="item[`content_${lang}`]"></div>
          <span class="text-tcdc-green readmore-link bold" v-if="item.slug && item.branch_id" @click="routeTo(item.slug, item.branch_id)">
            {{$t('service.readmore')}}
          </span>
        </v-col>
      </template>
    </v-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import {Utils} from "@/util/Utils";
  export default {
    props: {
      mode: {
        default: null
      }
    },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang,
      allBranches: state => state.Branch.branches,
      serviceAbout: state => {
        return [
          ...state.About.service_menu.map(service => ({
            branch_id: service.branch_id,
            title_th: service.title_th,
            title_en: service.title_en,
            icon: service.icon,
            slug: service.slug_url,
            content_th: service.description_th,
            content_en: service.description_en
          }))
        ]
      },
      serviceTopic: state => {
        return [
          ...state.ServiceMenu.service_menu.map(service => ({
            branch_id : service.branch_id,
            title_th : service.title_th,
            title_en : service.title_en,
            icon : service.icon,
            slug : service.slug_url,
            content_th : service.description_th,
            content_en : service.description_en
          }))
        ]
      }
    }),
  },
    methods: {
      async routeTo(url, branch_id) {
        if (url) {
          await this.$store.dispatch('Branch/getBranchById', branch_id);
          await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", {
            branch_id: branch_id,
            lang: this.lang
          });
          const branch = Utils.getBranchNameById(branch_id, this.allBranches);
          if (url[0] === '/') {
            this.$router.push(`/${this.lang}`+`${branch}/service${url}`);
          } else {
            this.$router.push(`/${this.lang}`+`${branch}/service/${url}`);
          }
        }
      }
    },
    created() {
    },
    data: () => ({

    })
};
</script>

<style lang="scss">
  .readmore-link:hover {
    border-bottom: solid 2px $tcdcGreen;
  }
  .readmore-link {
    cursor: pointer;
  }
</style>
